import { Routes } from '@angular/router';
import { roleGuard } from './guards/role-guard.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes-guard.guard';

export const routes: Routes = [
  {
    path: 'packages/:scope/:name',
    canActivate: [roleGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/package-detail/package-detail.page').then(
            (c) => c.PackageDetailPage,
          ),
        pathMatch: 'full',
      },
      {
        path: '**',
        loadComponent: () =>
          import('./pages/package-detail/package-detail.page').then(
            (c) => c.PackageDetailPage,
          ),
      },
    ],
  },
  {
    path: 'accounts/:accountId',
    loadComponent: () =>
      import('./pages/account/account.page').then((c) => c.AccountPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'discussions/:discussionId',
    loadComponent: () =>
      import('./pages/discussion/discussion.page').then(
        (c) => c.DiscussionPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'news/:newsItemId',
    loadComponent: () =>
      import('./pages/news-item/news-item.page').then((c) => c.NewsItemPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'support/:supportCaseId',
    loadComponent: () =>
      import('./pages/support-case/support-case.page').then(
        (c) => c.SupportCasePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'accounts',
    loadComponent: () =>
      import('./pages/accounts/accounts.page').then((c) => c.AccountsPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'admin-tools',
    loadComponent: () =>
      import('./pages/admin-tools/admin-tools.page').then(
        (c) => c.AdminToolsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator'] },
  },
  {
    path: 'discussions',
    loadComponent: () =>
      import('./pages/discussions/discussions.page').then(
        (c) => c.DiscussionsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'documents',
    canActivate: [roleGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/documents/documents.page').then(
            (c) => c.DocumentsPage,
          ),
        pathMatch: 'full',
      },
      {
        path: '**',
        loadComponent: () =>
          import('./pages/documents/documents.page').then(
            (c) => c.DocumentsPage,
          ),
      },
    ],
  },
  {
    path: 'events',
    loadComponent: () =>
      import('./pages/events/events.page').then((c) => c.EventsPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.page').then((c) => c.HomePage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((c) => c.LoginPage),
    pathMatch: 'full',
  },
  {
    path: 'manage-roles',
    loadComponent: () =>
      import('./pages/manage-roles/manage-roles.page').then(
        (c) => c.ManageRolesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator'] },
  },
  {
    path: 'new-discussion',
    loadComponent: () =>
      import('./pages/new-discussion/new-discussion.page').then(
        (c) => c.NewDiscussionPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'new-news-item',
    loadComponent: () =>
      import('./pages/new-news-item/new-news-item.page').then(
        (c) => c.NewNewsItemPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'news',
    loadComponent: () =>
      import('./pages/news/news.page').then((c) => c.NewsPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'no-account',
    loadComponent: () =>
      import('./pages/no-account/no-account.page').then((c) => c.NoAccountPage),
    pathMatch: 'full',
  },
  {
    path: 'not-authorized',
    loadComponent: () =>
      import('./pages/not-authorized/not-authorized.page').then(
        (c) => c.NotAuthorizedPage,
      ),
    pathMatch: 'full',
  },
  {
    path: 'packages',
    loadComponent: () =>
      import('./pages/packages/packages.page').then((c) => c.PackagesPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'personal-access-tokens',
    loadComponent: () =>
      import('./pages/personal-access-tokens/personal-access-tokens.page').then(
        (c) => c.PersonalAccessTokensPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./pages/profile/profile.page').then((c) => c.ProfilePage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'registry-authorize',
    loadComponent: () =>
      import('./pages/registry-authorize/registry-authorize.page').then(
        (c) => c.RegistryAuthorizePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'registry-tokens',
    loadComponent: () =>
      import('./pages/registry-tokens/registry-tokens.page').then(
        (c) => c.RegistryTokensPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'search',
    loadComponent: () =>
      import('./pages/search/search.page').then((c) => c.SearchPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'support',
    loadComponent: () =>
      import('./pages/support/support.page').then((c) => c.SupportPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'switch-user',
    loadComponent: () =>
      import('./pages/switch-user/switch-user.page').then(
        (c) => c.SwitchUserPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'user-activity',
    loadComponent: () =>
      import('./pages/user-activity/user-activity.page').then(
        (c) => c.UserActivityPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator'] },
  },
  {
    path: '',
    loadComponent: () =>
      import('./pages/landing/landing.page').then((c) => c.LandingPage),
    pathMatch: 'full',
  },
];
